import { watch } from 'vue';
import BaseTimeTicketEntitySetupService from '@/setup/time-ticket/BaseTimeTicketEntitySetupService';
import { qsFrom64, qsTo64 } from '@/utils/tools';
import usetimeTicketYearPagedListFilterService from '@/services/time-ticket/TimeTicketYearPagedListFilterService';
import useScrollService from '@/services/ScrollService';

type Props = SetupProps<typeof TimeTicketWeekCardSetupService.props>

export default class TimeTicketWeekCardSetupService extends BaseTimeTicketEntitySetupService<Props> {

	filterService = !this.route.query.tour ? usetimeTicketYearPagedListFilterService() : undefined;

	get isCurrentWeek () {
		return this.timeTicket.year === new Date().getFullYear() && this.timeTicket.weekNumber === new Date().getWeekNumber();
	}

	constructor (props: Props) {
		super(props);
		watch(() => this.props.timeTicket, (val) => {
			this.timeTicket.assignData(val);
		});
	}

	storeScrollAndNavigate () {
		const filter = this.route.query.filter
			? qsFrom64(this.route.query.filter.toString())
			: {};

		if (this.filterService?.filter.research) {
			filter.research = this.filterService.filter.research;
		} //TODO:

		useScrollService().storeWindowScroll();
		this.router.push({
			name: 'TimeTicketWeek',
			params: {
				year: this.timeTicket.year,
				weekNumber: this.timeTicket.weekNumber,
			},
			query: { filter: qsTo64(filter) },
		});
	}
}
